export default __webpack_public_path__ + "static/assets/1dc5eeac2c16e0fe96ab28076902898c.svg";